// src/pages/Home.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useScrollReveal from '../hooks/useScrollReveal';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();
  const [scrollDir, setScrollDir] = useState('up');
  const [lastScrollTop, setLastScrollTop] = useState(0);

  // Detect scroll direction for navbar or scroll indicator visibility
  useEffect(() => {
    const handleScroll = () => {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > lastScrollTop) {
        setScrollDir('down');
      } else {
        setScrollDir('up');
      }
      setLastScrollTop(st <= 0 ? 0 : st);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollTop]);

  // Scroll reveal animations
  useScrollReveal('.section');
  useScrollReveal('.card', true); // staggered reveal

  return (
    <div className="home-container">
      {/* Scroll indicator with direction-based visibility */}
      <div className={`scroll-indicator ${scrollDir === 'down' ? 'hide' : 'show'}`}>
        <span></span>
      </div>

      {/* Sections */}
      <section className="section hero reveal">
        <div className="hero-content">
          <h1>Welcome to Talyfax</h1>
          <p>Innovating your digital experience with products, services, and blogs.</p>
          <div className="cta-buttons">
            <button onClick={() => navigate('/offerings')}>Explore Services</button>
            <button className="secondary" onClick={() => navigate('/contact')}>
              Get in Touch
            </button>
          </div>
        </div>
      </section>

      <section className="section about reveal">
        <div className="about-content">
          <h2>Who We Are</h2>
          <p>
            At <span className="brand">Talyfax</span>, we deliver cutting-edge web, mobile, and AI
            solutions to help businesses thrive in the digital era. Our mission is to make
            technology accessible, scalable, and impactful.
          </p>
        </div>
      </section>

      <section className="section highlights reveal">
        <h2>What We Offer</h2>
        <div className="highlight-cards">
          <div className="card reveal" onClick={() => navigate('/offerings')}>
            <h3>Web Development</h3>
            <p>Modern, responsive, and scalable websites.</p>
          </div>
          <div className="card reveal" onClick={() => navigate('/offerings')}>
            <h3>Mobile Apps</h3>
            <p>Cross-platform apps with seamless UX.</p>
          </div>
          <div className="card reveal" onClick={() => navigate('/offerings')}>
            <h3>AI Solutions</h3>
            <p>Intelligent tools to supercharge your business.</p>
          </div>
        </div>
      </section>

      <section className="section careers-teaser reveal">
        <div className="careers-content">
          <h2>Join Our Team</h2>
          <p>
            We’re always looking for passionate innovators to shape the future of digital
            experiences.
          </p>
          <button onClick={() => navigate('/careers')}>See Open Roles</button>
        </div>
      </section>

      <section className="section contact-cta reveal">
        <div className="contact-content">
          <h2>Let’s Build Something Amazing Together</h2>
          <button onClick={() => navigate('/contact')}>Request a Quote</button>
        </div>
      </section>
    </div>
  );
};

export default Home;
